<button class="u-outline" cypressTag="Shared.VideoModal.Button" (click)="handleButtonClick()">
	<div class="image-wrapper">
		<img alt="" [src]="videoData.thumbnail" />

		<vlaio-icon icon="fa-play" />
	</div>

	<ng-content></ng-content>
</button>
